import styles from "./ModalSkeleton.module.scss";

export const ModalFooterSkeleton = () => (
  <div className={styles.buttons}>
    <div className={`${styles.button} skeleton`} />
    <div className={`${styles.button} skeleton`} />
  </div>
);

const ModalSkeleton = () => {
  return (
    <div className={styles.modalSkeleton}>
      <div className={styles.tabs}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className={`${styles.tab} skeleton`} />
        ))}
      </div>

      <div className={styles.content}>
        <div className={styles.left}>
          <div className={`${styles.input} skeleton`} />
          <div className={`${styles.textarea} skeleton`} />
          <div className={`${styles.input} skeleton`} />
          <div className={`${styles.inputSmall} skeleton`} />
        </div>

        <div className={styles.right}>
          <div className={`${styles.image} skeleton`} />
          <div className={`${styles.input} skeleton`} />
        </div>
      </div>

      <ModalFooterSkeleton />
    </div>
  );
};

export default ModalSkeleton;
